import {
  number,
  minValue,
} from 'react-admin';

import { offeringCategory } from './helpers/mappings';

// eslint-disable-next-line no-useless-escape
export const validateAddress = x => (/^[a-zA-Z0-9\s~`!@#$%^&*()_+\-=\[\{\]\}|:',.\/? ]+$/mg.test(x));

export const validateShortUrl = x => ((/^[a-z0-9_]*$/.test(x)) ? undefined : 'Can only contain lowercase letters, numbers and underscores');

export const isRequired = v => (v ? undefined : 'Required');

export const isNumericRequired = v => (v >= 0 ? undefined : 'Required');

export const isBooleanRequired = v => ([0, 1, false, true].includes(v) ? undefined : 'Required');

export const isPostiveDecimal = (v) => {
  const d = Number.parseFloat(v);
  if (d < 0) {
    return 'Value must be >= 0';
  }
  if (Number.isNaN(d)) {
    return 'Value must be a number';
  }
  return undefined;
};

export const isLargerThan0Decimal = (v) => {
  const d = Number.parseFloat(v);
  if (d <= 0) {
    return 'Value must be > 0';
  }
  if (Number.isNaN(d)) {
    return 'Value must be a number';
  }
  return undefined;
};

export const isPositiveInt = (v) => {
  const d = Number.parseInt(v, 10);
  if (d < 0) {
    return 'Value must be >= 0';
  }
  if (Number.isNaN(d)) {
    return 'Value must be a number';
  }
  return undefined;
};

export const optionalNumber = [number(), minValue(0)];

export const priceValidation = (values) => {
  const errors = {};
  if (values) {
    /**
     * Total Raise Amount Check
     */
    if (values.minTotalRaiseCurrencyAmt > values.maxTotalRaiseCurrencyAmt) {
      errors.minTotalRaiseCurrencyAmt = ['Minimum Raise Amount must be less than Maximum Raise Amount'];
    }

    /**
     * Min Share Price Check
     */
    if (values.minSharePrice > values.maxSharePrice) {
      errors.minSharePrice = ['Minimum Share Price must be less than Maximum Share Price'];
    }

    /**
     * Invest Currency Amount Check
     */
    if (
      values.maximumInvestCurrencyAmt &&
      (values.minimumInvestCurrencyAmt > values.maximumInvestCurrencyAmt)
    ) {
      errors.minimumInvestCurrencyAmt = ['Minimum Investment Curreny must be less than Maximum Investment Currnecy'];
    }

    /**
     * Invest Share Amount Check
     */
    if (values.minimumInvestShareQty > values.maximumInvestShareQty) {
      errors.minimumInvestShareQty = ['Minimum Invest Share amount must be less than Maximum Invest Share Amount'];
    }
  }

  return errors;
};

export const comingSoonValidation = (values) => {
  let errors = {};
  if (values) {
    if (values.category !== offeringCategory.COMING_SOON.value) {
      // info validation
      if (!values.status) {
        errors.status = 'Offer Status is required';
      }
      if (!values.startDate) {
        errors.startDate = 'Offer Start Date is required';
      }
      // TODO close dates need to be checked against recurring also
      if (!values.closeDate && values.recurring && (values.closeDates && values.closeDates.length === 0)) {
        errors.closeDates = 'At least 1 close date is required';
      }
      if (!values.closeDate && !values.closeDates && (values.recurring === undefined || !values.recurring)) {
        errors.closeDate = 'Offer Close Date is requried';
      }
      if (!values.offerType) {
        errors.offerType = 'Offer Type is required';
      }
      if (!values.industry) {
        errors.industry = 'Offer Industry is required';
      }
      if (!values.sector) {
        errors.sector = 'Offer Sector is required';
      }
      if (!values.securityType) {
        errors.securityType = 'Offer Security Type is required';
      }
      if (!values.yield) {
        errors.yield = 'Yield is required';
      }
      if (!values.yieldDescription) {
        errors.yieldDescription = 'Offer Yield Description is required';
      }
      if (!values.exitDescription) {
        errors.exitDescription = 'Offer Exit Description is required';
      }
      // price validation
      const priceErrors = priceValidation(values);
      errors = Object.assign(errors, priceErrors);
      const minTotalRaiseCurrencyAmtError = isPostiveDecimal(values.minTotalRaiseCurrencyAmt);
      if (minTotalRaiseCurrencyAmtError !== undefined) {
        errors.minTotalRaiseCurrencyAmt = minTotalRaiseCurrencyAmtError;
      }
      const maxTotalRaiseCurrencyAmtError = isPostiveDecimal(values.maxTotalRaiseCurrencyAmt);
      if (maxTotalRaiseCurrencyAmtError !== undefined) {
        errors.maxTotalRaiseCurrencyAmt = maxTotalRaiseCurrencyAmtError;
      }
      if (values.category === offeringCategory.NORMAL.value) {
        const pricePerShareError = isPostiveDecimal(values.pricePerShare);
        if (pricePerShareError !== undefined) {
          errors.pricePerShare = pricePerShareError;
        }
      }
      const minimumInvestIncCurrencyAmtError = isPositiveInt(values.minimumInvestIncCurrencyAmt);
      if (minimumInvestIncCurrencyAmtError !== undefined) {
        errors.minimumInvestIncCurrencyAmt = minimumInvestIncCurrencyAmtError;
      }
      const minimumInvestCurrencyAmtError = isPostiveDecimal(values.minimumInvestCurrencyAmt);
      if (minimumInvestCurrencyAmtError !== undefined) {
        errors.minimumInvestCurrencyAmt = minimumInvestCurrencyAmtError;
      }
      // description, disclaimer, documents
      if (!values.description) {
        errors.description = 'Offer Description is required';
      }
      if (!values.disclaimer) {
        errors.disclaimer = 'Offer Disclaimer is required';
      }
      if (!values.description) {
        errors.description = 'Offer Description is required';
      }
      if (!values.documents || Object.keys(values.documents).length === 0 || values.documents.filter(o => Object.keys(o).length > 0).length === 0) {
        errors.documents = 'At least 1 document is required';
      }
      if (!values.docType) {
        errors.docType = 'Offer Document Type is required';
      }
      // eslint-disable-next-line no-underscore-dangle
      if (!values._document) {
        // eslint-disable-next-line no-underscore-dangle
        errors._document = 'offer Document File is required';
      }
    }
  }
  return errors;
};

export const validateOffer = comingSoonValidation;




// WEBPACK FOOTER //
// ./src/validators.js